import {Injectable} from '@angular/core';
import {PaginatorService} from "@shared/api/services/paginator.service";
import {License} from "@shared/api/models/query/license.model";

@Injectable({
    providedIn: 'root'
})
export class LicensesService extends PaginatorService<License> {

    protected override get domainEntity() {
        return 'lists/licenses';
    };
}
